import { blogIndexQueryProduction, blogIndexQueryPreview } from '@lib/queries';
import { getClient, overlayDrafts } from '@lib/sanity.server';
import { singlePageProps } from '@lib';
import { Listing } from '@components';
import { isProduction } from 'utils';
import { Feed } from 'feed';
import { urlForImage } from '@lib/sanity';
import fs from 'fs';

export default Listing;

export async function getStaticProps({ preview = false }) {
  const slug = '/blog';
  const singlePage = await singlePageProps({ preview, slug });
  const allBlogs = overlayDrafts(
    await getClient(preview).fetch(
      isProduction ? blogIndexQueryProduction : blogIndexQueryPreview
    )
  );

  const generateRssFeed = async () => {
    const feed = new Feed({
      title: 'Clerk Blog',
      description: `Stay up to date with all of Clerk's latest news.`,
      id: 'https://clerk.com/blog',
      link: 'https://clerk.com/blog',
      language: 'en', // optional, used only in RSS 2.0, possible values: http://www.w3.org/TR/REC-html40/struct/dirlang.html#langcodes
      image: 'https://twitter.com/ClerkDev/photo',
      favicon: 'https://clerk.com/favicon/favicon.ico',
      copyright: `All rights reserved ${new Date().getFullYear()}, Clerk`,
      author: {
        name: 'Clerk Team',
        email: 'support@clerk.dev',
        link: 'https://clerk.com/support'
      }
    });

    // @ts-ignore
    allBlogs.forEach(post => {
      const url = urlForImage(post.coverImage.asset).url() || '';

      feed.addItem({
        title: post.title,
        id: `https://clerk.com${post.slug}`,
        link: `https://clerk.com${post.slug}`,
        description: post.excerpt,
        author: [
          {
            name: post.author.name
          }
        ],
        date: new Date(post.date),
        image: url
      });
    });

    fs.mkdirSync('./public/rss', { recursive: true });
    fs.writeFileSync(
      './public/rss/feed.xml',
      feed
        .rss2()
        .replace(/&/g, '&amp;')
        .replace('&amp;&amp;', '&amp;')
        .replace(
          '<channel>',
          '<channel><atom:link href="http://clerk.com/rss/atom.xml" rel="self" type="application/rss+xml" />'
        )
        .replace(
          `<rss version="2.0">`,
          `<rss version="2.0" xmlns:atom="http://www.w3.org/2005/Atom">`
        )
    );
    fs.writeFileSync('./public/rss/atom.xml', feed.atom1());
    fs.writeFileSync('./public/rss/feed.json', feed.json1());
  };

  await generateRssFeed();

  return {
    props: {
      allBlogs,
      categories: allBlogs.reduce((acc, { category }) => {
        if (!acc.includes(category)) {
          acc.push(category);
        }
        return acc;
      }, []),
      ...singlePage.props
    }
  };
}
